export default "__VITE_ASSET__DtoXjTRv__"